export default __webpack_public_path__ + "static/media/s2.c86371da.jpg";